import { makeAutoObservable } from 'mobx';
import { Options } from '~/definitions/ballot';
import { MemberCustomerDirectorySessionData } from '~/types/memberCustomerDirectorySession';
import { Region } from '~/definitions/region';
import { Election } from '~/definitions/election';
import { Company } from '~/definitions/company';
import { onSlagChange } from './fn/onSlagChange';
import getIsStandAdmin from './fn/getIsStandAdmin';
import getStandAdminId from './fn/getStandAdminId';
import getNoActiveElectionError from './fn/getNoActiveElectionError';
import onClickSeeCandidates from './fn/onClickSeeCandidates';
import getLoginErrorMessage from './fn/getLoginErrorMessage';
import { LoginErrorValue } from '~/const/login';
import getErrorTitleMessage from './fn/getErrorTitleMessage';

export default class BallotStore {
    isInitialized: boolean = false;
    isStandAdminInitialized: boolean = false;
    isLoginErrorInitialized: boolean = false;
    coopId: string = '';
    customers: MemberCustomerDirectorySessionData['customers'] | null = null;

    allSlagList: Options[] = [];
    ballotSlagList: Options[] = [];
    showJobPositionAndCity: string = 'all';

    selectedElectionId: string = '';
    selectedSlagId: string = '';
    selectedRegionId: string = '';
    selectedZipcode: string = '';
    slagPage: string = '';

    company?: Company = undefined;
    election?: Election = undefined;
    region?: Region = undefined;

    coopMainDomain: string = '';

    isUpdatingSlag: boolean = false;
    isShownCandidates: boolean = false;
    isElectionInitialized: boolean = false;

    standAdminId?: string = '';
    standAdminLoginError: string = '';

    loginError?: LoginErrorValue = undefined;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.coopId = '';
        this.isInitialized = false;
        this.isLoginErrorInitialized = false;
        this.isStandAdminInitialized = false;
        this.customers = null;

        this.selectedElectionId = '';
        this.selectedSlagId = '';
        this.selectedRegionId = '';
        this.selectedZipcode = '';

        this.company = undefined;
        this.election = undefined;
        this.region = undefined;

        this.coopMainDomain = '';

        this.isUpdatingSlag = false;
        this.isShownCandidates = false;
        this.standAdminId = undefined;
        this.standAdminLoginError = '';
        this.isElectionInitialized = false;
        this.loginError = undefined;
    }

    setIsInitialized = (value: boolean): void => {
        this.isInitialized = value;
    };

    setIsLoginErrorInitialized = (value: boolean): void => {
        this.isLoginErrorInitialized = value;
    };

    setIsElectionInitialized = (value: boolean): void => {
        this.isElectionInitialized = value;
    };

    setCoopId = (value: string): void => {
        this.coopId = value;
    };

    setCustomers = (value: MemberCustomerDirectorySessionData['customers']): void => {
        this.customers = value;
    };

    setAllSlagList = (allSlagList: Options[]) => {
        this.allSlagList = allSlagList;
    };

    setBallotSlagList = (ballotSlagList: Options[]) => {
        this.ballotSlagList = ballotSlagList;
    };

    setSelectedElectionId = (id: string) => {
        this.selectedElectionId = id;
    };

    setSelectedSlagId = (slagId: string) => {
        this.selectedSlagId = slagId;
    };

    setSelectedRegionId = (id: string) => {
        this.selectedRegionId = id;
    };

    setSelectedZipcode = (zipcode: string) => {
        this.selectedZipcode = zipcode;
    };

    setSlagPage = (page: string): void => {
        this.slagPage = page;
    };

    setRegion = (region: Region): void => {
        this.region = region;
    };

    setCoopMainDomain = (domain: string): void => {
        this.coopMainDomain = domain;
    };

    setElection = (election: Election) => {
        this.election = election;
    };

    setCompany = (company: Company): void => {
        this.company = company;
    };

    setIsUpdatingSlag = (value: boolean): void => {
        this.isUpdatingSlag = value;
    };

    setIsShownCandidates = (value: boolean): void => {
        this.isShownCandidates = value;
    };

    setStandAdminId = (id: string): void => {
        this.standAdminId = id;
    };

    setStandAdminLoginError = (value: string): void => {
        this.standAdminLoginError = value;
    };

    setLoginError = (value: LoginErrorValue): void => {
        this.loginError = value;
    };

    setIsStandAdminInitialized = (value: boolean): void => {
        this.isStandAdminInitialized = value;
    };

    setShowJobPositionAndCity = (value: string): void => {
        this.showJobPositionAndCity = value;
    };

    getIsLoggedIn = (): boolean => {
        return !!this.coopId;
    };

    getAllSlagList = (): Options[] => {
        return this.allSlagList;
    };

    getBallotSlagList = (): Options[] => {
        return this.ballotSlagList;
    };

    getNoActiveElectionError = getNoActiveElectionError;
    onSlagChange = onSlagChange;
    getLoginErrorMessage = getLoginErrorMessage;
    getErrorTitleMessage = getErrorTitleMessage;
    getIsStandAdmin = getIsStandAdmin;
    getStandAdminId = getStandAdminId;
    onClickSeeCandidates = onClickSeeCandidates;
}
